import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export const fetchDashboardHeaderCount = () => {
  return axiosRequest('get', serviceUrls.DASHBOARD_HEADER_COUNT);
};

export const fetchEngagements = () => {
  return axiosRequest('get', serviceUrls.ENGAGEMENTS_LIST);
};

export function fetchCasePhasesService(caseManagerId = '') {
  return axiosRequest('get', serviceUrls.DASHBOARD_CASE_PHASES, { caseManagerId });
}

export function fetchConctactsService() {
  return axiosRequest('get', serviceUrls.DASHBOARD_CONTACTS);
}

export function fetchFavoriteCasesService(filter) {
  return axiosRequest('post', serviceUrls.DASHBOARD_FAVORITE_TABLE, filter, { timeout: 300000 });
}



// WEBPACK FOOTER //
// ./src/services/dashboard.service.js